export default __webpack_public_path__ + "static/media/harvard.c7cc3e97.jpg";